import { render, staticRenderFns } from "./PolicyForm.vue?vue&type=template&id=0a7f0811&scoped=true"
import script from "./PolicyForm.vue?vue&type=script&lang=ts"
export * from "./PolicyForm.vue?vue&type=script&lang=ts"
import style0 from "./PolicyForm.vue?vue&type=style&index=0&id=0a7f0811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f0811",
  null
  
)

export default component.exports